import { useNavigate } from "react-router-dom";

import { useStoredUrlParams } from "./useUrlParamsToSessionStorage";

import type { PreparationTaskKey } from "./usePreparationTasks";

export const useNavigates = () => {
  const navigate = useNavigate();
  const storedParams = useStoredUrlParams();

  const navigateConsultationDetail = (id: string) => {
    navigate(`/consultations/${id}`);
  };

  // 予約詳細へ遷移し、事前準備(事前問診 or 目の画像)の登録モーダルを自動で開く
  const navigateConsultationPreparation = (
    id: string,
    task: PreparationTaskKey
  ) => {
    navigate(`/consultations/${id}?openPreparation=${task}`);
  };

  const navigateOnlineConsultation = (id?: string) => {
    navigate(`/onlineConsultation/${id}`);
  };

  const navigateHome = (done?: string) => {
    navigate(`${done ? done : "/"}`);
  };

  const navigateAddPaymentMethod = () => {
    navigate("/addPaymentMethod");
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const navigateSignUpFinish = () => {
    navigate("/signUpFinish");
  };

  const navigateUserRegister = () => {
    navigate("/userRegister");
  };

  const navigateConfirmSignUp = (email: string, password: string) => {
    navigate("/confirmSignUp", { state: { email: email, password: password } });
  };

  const navigateUsageHistory = () => {
    navigate("/usageHistory");
  };

  const navigateLogin = () => {
    navigate("/");
  };

  const navigateReEntryRoom = (id: string) => {
    navigate(`/reEntryRoom/${id}`);
  };

  // URLパラメータを構築するヘルパー関数
  const buildUrlWithStoredParams = (
    baseUrl: string,
    additionalParams: Record<string, string | boolean> = {}
  ) => {
    const url = new URL(baseUrl, window.location.origin);

    // 追加パラメータを設定
    Object.entries(additionalParams).forEach(([key, value]) => {
      url.searchParams.set(key, String(value));
    });

    // セッションストレージからcouponとtypeを取得して追加
    if (storedParams?.coupon) {
      url.searchParams.set("coupon", storedParams.coupon);
    }
    if (storedParams?.type) {
      url.searchParams.set("type", storedParams.type);
    }

    return url.pathname + url.search;
  };

  const navigateReConsultation = (id: string, step: number | string) => {
    const url = buildUrlWithStoredParams(`/reConsultations/${id}`, {
      step: String(step),
    });
    navigate(url);
  };

  const navigateConsultationsNew = (
    step: number | string,
    isUpdate: boolean = false
  ) => {
    const url = buildUrlWithStoredParams("/consultations", {
      step: String(step),
      isUpdate,
    });
    navigate(url);
  };

  const navigateConsultationsConfirm = (isUpdate: boolean = false) => {
    const url = buildUrlWithStoredParams("/consultations", {
      step: "confirm",
      isUpdate,
    });
    navigate(url);
  };

  return {
    navigateHome,
    navigateBack,
    navigateConsultationDetail,
    navigateConsultationPreparation,
    navigateReConsultation,
    navigateOnlineConsultation,
    navigateAddPaymentMethod,
    navigateSignUpFinish,
    navigateUserRegister,
    navigateConfirmSignUp,
    navigateLogin,
    navigateUsageHistory,
    navigateReEntryRoom,
    navigateConsultationsNew,
    navigateConsultationsConfirm,
  };
};
